import "./MerchantDashboard.css";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { Tooltip } from "react-tooltip";
import { MdCurrencyRupee, MdWebhook } from "react-icons/md";
import { FaBagShopping } from "react-icons/fa6";
import { HiBanknotes } from "react-icons/hi2";
import { useSelector } from "react-redux";
import { maskValue } from "../index";

function Firstsection({ payInStatistic, payoutStatistic, webhookRatio }) {
  const showValues = useSelector((s) => s.userReducer.showValues);
  const role = useSelector((state) => state.userReducer.role);

  let payoutNet = payoutStatistic
    ? payoutStatistic.payoutAmount
      ? payoutStatistic.payoutTotalComission
        ? payoutStatistic.payoutAmount + payoutStatistic.payoutTotalComission
        : payoutStatistic.payoutAmount
      : "0"
    : "0";

  return (
    <div>
      <div data-tour="stats-cards" className="first-section">
        <div className="left-section-new">
          <div className="left-section-2">
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Payin Volume</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element1"
                  style={{
                    color: "#878a99",
                  }}
                />

                <Tooltip
                  anchorSelect=".my-anchor-element1"
                  place="top"
                  className="custom-reduce"
                >
                  Total Number Of Payin Transactions
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {maskValue(
                    payInStatistic ? payInStatistic.payInTotal : "0",
                    showValues
                  )}
                </p>
                <div className="icon-div">
                  <FaBagShopping
                    style={{
                      width: "1rem",
                      height: "1rem",
                      color: "white",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Deposits</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element"
                  style={{
                    color: "#878a99",
                  }}
                />

                <Tooltip
                  anchorSelect=".my-anchor-element"
                  place="top"
                  className="custom-reduce"
                >
                  Total Payin Amount Without Comission And Rolling Reserve
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  ₹{" "}
                  {maskValue(
                    payInStatistic
                      ? payInStatistic.payinAmount
                        ? Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(payInStatistic.payinAmount)
                        : "0"
                      : "0",
                    showValues
                  )}
                </p>
                <div className="icon-div">
                  <MdCurrencyRupee
                    style={{
                      width: "1rem",
                      height: "1rem",
                      color: "white",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Post Commission Payin Amount</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element2"
                  style={{
                    color: "#878a99",
                  }}
                />

                <Tooltip
                  anchorSelect=".my-anchor-element2"
                  place="top"
                  className="custom-reduce"
                >
                  Payin After Comission and Rolling Reserve is Deducted
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  ₹{" "}
                  {maskValue(
                    payInStatistic
                      ? payInStatistic.payinAmount
                        ? Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(
                            payInStatistic.payinAmount -
                              payInStatistic.payinTotalComission -
                              payInStatistic.payinRollingReserve
                          )
                        : "0"
                      : "0",
                    showValues
                  )}
                </p>

                <div className="icon-div">
                  <HiBanknotes
                    style={{
                      width: "1rem",
                      height: "1rem",
                      color: "white",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Payout Volume</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element4"
                  style={{
                    color: "#878a99",
                  }}
                />

                <Tooltip
                  anchorSelect=".my-anchor-element4"
                  place="top"
                  className="custom-reduce"
                >
                  Total Number Of Payout Transactions
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {maskValue(
                    payoutStatistic
                      ? payoutStatistic.payOutTotal
                        ? payoutStatistic.payOutTotal
                        : "0"
                      : "0",
                    showValues
                  )}
                </p>

                <div className="icon-div">
                  <FaBagShopping
                    style={{
                      width: "1rem",
                      height: "1rem",
                      color: "white",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Withdrawals</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element5"
                  style={{
                    color: "#878a99",
                  }}
                />

                <Tooltip
                  anchorSelect=".my-anchor-element5"
                  place="top"
                  className="custom-reduce"
                >
                  Total Payout Amount Without Comission (Success + Processing)
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  ₹{" "}
                  {maskValue(
                    payoutStatistic
                      ? payoutStatistic.payoutAmount
                        ? Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(payoutStatistic.payoutAmount)
                        : "0"
                      : "0",
                    showValues
                  )}
                </p>

                <div className="icon-div">
                  <MdCurrencyRupee
                    style={{
                      width: "1rem",
                      height: "1rem",
                      color: "white",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Post Commission Payout Amount</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element6"
                  style={{
                    color: "#878a99",
                  }}
                />

                <Tooltip
                  anchorSelect=".my-anchor-element6"
                  place="top"
                  className="custom-reduce"
                >
                  Payout with Comission Added (Success + Processing)
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  ₹{" "}
                  {maskValue(
                    Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(payoutNet),
                    showValues
                  )}
                </p>

                <div className="icon-div">
                  <HiBanknotes
                    style={{
                      width: "1rem",
                      height: "1rem",
                      color: "white",
                    }}
                  />
                </div>
              </div>
            </div>
            {/* payout process */}
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Processing Payout Volume</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element14"
                  style={{
                    color: "#878a99",
                  }}
                />

                <Tooltip
                  anchorSelect=".my-anchor-element14"
                  place="top"
                  className="custom-reduce"
                >
                  Total Number Of Payout Transactions in Processing state
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  {maskValue(
                    payoutStatistic
                      ? payoutStatistic.payoutPending
                        ? payoutStatistic.payoutPending
                        : "0"
                      : "0",
                    showValues
                  )}
                </p>

                <div className="icon-div">
                  <FaBagShopping
                    style={{
                      width: "1rem",
                      height: "1rem",
                      color: "white",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Total Withdrawals in Processing</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element15"
                  style={{
                    color: "#878a99",
                  }}
                />

                <Tooltip
                  anchorSelect=".my-anchor-element15"
                  place="top"
                  className="custom-reduce"
                >
                  Total Payout Amount Without Comission of Processing
                </Tooltip>
              </div>
              <div className="data-icon-box">
                <p className="sub-heading-new">
                  ₹{" "}
                  {maskValue(
                    payoutStatistic
                      ? payoutStatistic.payoutOutProcessing
                        ? Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(payoutStatistic.payoutOutProcessing)
                        : "0"
                      : "0",
                    showValues
                  )}
                </p>

                <div className="icon-div">
                  <MdCurrencyRupee
                    style={{
                      width: "1rem",
                      height: "1rem",
                      color: "white",
                    }}
                  />
                </div>
              </div>
            </div>

            {role === "super" && (
              <div className="new-section">
                <div className="data-icon-box">
                  <p className="heading-new">Webhook Ratio</p>
                  <IoMdInformationCircleOutline
                    className="my-anchor-element16"
                    style={{
                      color: "#878a99",
                    }}
                  />

                  <Tooltip
                    anchorSelect=".my-anchor-element16"
                    place="top"
                    className="custom-reduce"
                  >
                    Count of webhook received: {webhookRatio.received} <br />
                    Count of webhook sent: {webhookRatio.sent}
                  </Tooltip>
                </div>
                <div className="data-icon-box">
                  <p className="sub-heading-new">{webhookRatio.ratio}</p>

                  <div className="icon-div">
                    <MdWebhook
                      style={{
                        width: "1rem",
                        height: "1rem",
                        color: "white",
                      }}
                    />
                  </div>
                </div>
              </div>
            )}

            {(role === "admin" || role === "subAdmin") && (
              <div className="new-section">
                <div className="data-icon-box">
                  <p className="heading-new">Total Rolling Reserve Released </p>
                  <IoMdInformationCircleOutline
                    className="my-anchor-element10"
                    style={{
                      color: "#878a99",
                    }}
                  />

                  <Tooltip
                    anchorSelect=".my-anchor-element10"
                    place="top"
                    className="custom-reduce"
                  >
                    Total Paid Rolling Reserve
                  </Tooltip>
                </div>
                <div className="data-icon-box">
                  <p className="sub-heading-new">
                    ₹{" "}
                    {maskValue(
                      payInStatistic
                        ? payInStatistic.payinRollingReservePaid
                          ? Intl.NumberFormat("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(payInStatistic.payinRollingReservePaid)
                          : "0"
                        : "0",
                      showValues
                    )}
                  </p>

                  <div className="icon-div">
                    <MdCurrencyRupee
                      style={{
                        width: "1rem",
                        height: "1rem",
                        color: "white",
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {/* <div className="new-section">
              <div className="data-icon-box">
                <p className="heading-new">Net Processing Payout Amount</p>
                <IoMdInformationCircleOutline
                  className="my-anchor-element5"
                  style={{
                    color: "#878a99",
                  }}
                />

                <Tooltip
                  anchorSelect=".my-anchor-element5"
                  place="top"
                  className="custom-reduce"
                >
                  Total Comission Amount of Processing
                </Tooltip>
              </div>
             <div className="data-icon-box">
              <p className="sub-heading-new">
                ₹{" "}
                {maskValue(
                  payoutStatistic
                    ? payoutStatistic.totalProcessingCommision
                      ? Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(payoutStatistic.totalProcessingCommision)
                      : "0"
                    : "0",
                  showValues
                )}
              </p>

              <div className="icon-div">
                <MdCurrencyRupee
                  style={{
                    width: "1rem",
                    height: "1rem",
                    color: "white",
                  }}
                />
              </div>
            </div>
            </div> */}
            {/* payout process end */}
          </div>
        </div>

        <div className="stats-wrapper">
          <div className="new-section-1">
            <div className="comm-side">
              <p className="heading-new">Total Commission</p>
              <p className="sub-heading-new">
                ₹{" "}
                {maskValue(
                  payoutStatistic
                    ? payInStatistic
                      ? payInStatistic.payinTotalComission
                        ? payoutStatistic.payoutTotalComission
                          ? Intl.NumberFormat("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(
                              payInStatistic.payinTotalComission +
                                payoutStatistic.payoutTotalComission
                            )
                          : Intl.NumberFormat("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(payInStatistic.payinTotalComission)
                        : "0"
                      : payoutStatistic.payoutTotalComission
                        ? Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(payoutStatistic.payoutTotalComission)
                        : "0"
                    : "0",
                  showValues
                )}
              </p>
            </div>

            <div className="comm-side">
              <p className="heading-new">Commission For Payin</p>
              <p className="sub-heading-new">
                ₹{" "}
                {maskValue(
                  payInStatistic
                    ? payInStatistic.payinTotalComission
                      ? Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(payInStatistic.payinTotalComission)
                      : "0"
                    : "0",
                  showValues
                )}
              </p>
            </div>

            <div className="comm-side">
              <p className="heading-new">Commission For Payout</p>
              <p className="sub-heading-new">
                ₹{" "}
                {maskValue(
                  payoutStatistic
                    ? payoutStatistic.payoutTotalComission
                      ? Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(payoutStatistic.payoutTotalComission)
                      : "0"
                    : "0",
                  showValues
                )}
              </p>
            </div>
          </div>
          {role === "admin" ||
            (role === "super" && (
              <div className="new-section">
                <div className="data-icon-box">
                  <p className="heading-new">Amount held against complaints</p>
                  <IoMdInformationCircleOutline
                    className="my-anchor-element50"
                    style={{
                      color: "#878a99",
                    }}
                  />

                  <Tooltip
                    anchorSelect=".my-anchor-element50"
                    place="top"
                    className="custom-reduce"
                  >
                    Total Amount held against complaints
                  </Tooltip>
                </div>
                <div className="data-icon-box">
                  <p className="sub-heading-new">
                    ₹{" "}
                    {maskValue(
                      payInStatistic
                        ? payInStatistic.recoveredAmount
                          ? Intl.NumberFormat("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(payInStatistic.recoveredAmount)
                          : "0"
                        : "0",
                      showValues
                    )}
                  </p>

                  <div className="icon-div">
                    <MdCurrencyRupee
                      style={{
                        width: "1rem",
                        height: "1rem",
                        color: "white",
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default Firstsection;

//again push
